import { point } from '../../../elements/point';
import {
  ICON_DEFAULT_ACCENT_COLOR,
  ICON_DEFAULT_FOREGROUND_COLOR,
} from '../../../graphConstants';
import { makeTag } from '../../../svg/utils';
import {
  type NodeIconOptions,
  type NodeTypeIcon,
  nodeIconDefaultOptions,
} from '../NodeTypeIcon';
import {
  createSquareNodeTypeIcon,
  getArrowSvgPath,
  wrapNodeIconInSvgTag,
} from '../common';
import { drawSquareBackground } from '../drawIconBackground';

const ICON_SIZE = 40;
const ARROW_INNER_OFFSET = 12.4;
const ARROW_OUTER_OFFSET = 4.4;

function createL3SwitchIcon(options: NodeIconOptions = {}): string {
  const opts = { ...nodeIconDefaultOptions, ...options };
  const inner = {
    first: ARROW_INNER_OFFSET,
    second: ICON_SIZE - ARROW_INNER_OFFSET,
  };
  const outer = {
    first: ARROW_OUTER_OFFSET,
    second: ICON_SIZE - ARROW_OUTER_OFFSET,
  };

  const drawArrow = (coordX: 'first' | 'second', coordY: 'first' | 'second') =>
    makeTag('path', {
      d: getArrowSvgPath({
        from: point.create(inner[coordX], inner[coordY]),
        to: point.create(outer[coordX], outer[coordY]),
        headWidth: 9.2,
        headHeight: 4.8,
        tailWidth: 3.6,
      }),
      fill: ICON_DEFAULT_FOREGROUND_COLOR,
    });

  const icon = `
    ${drawSquareBackground(ICON_SIZE, opts.style)}
    ${drawArrow('first', 'first')}
    ${drawArrow('first', 'second')}
    ${drawArrow('second', 'first')}
    ${drawArrow('second', 'second')}
    ${makeTag('circle', {
      cx: 20,
      cy: 20,
      fill: ICON_DEFAULT_ACCENT_COLOR,
      r: 7.2,
    })}
  `;

  return wrapNodeIconInSvgTag(icon, ICON_SIZE, ICON_SIZE, 'topLeft', opts);
}

export const l3SwitchIcon: NodeTypeIcon = createSquareNodeTypeIcon(
  ICON_SIZE,
  createL3SwitchIcon,
);
